import React, { ComponentProps } from "react";
import { a } from "kremling";

type DrawerBodyProps = ComponentProps<"div">;

export const DrawerBody: React.FC<DrawerBodyProps> = ({
  children,
  className,
  ...rest
}) => (
  <div className={a("cp-drawer__body", className)} {...rest}>
    {children}
  </div>
);
